/**
 * Created by Ivan on 04.02.2026
 */

const KingsCupVertical = cc.Node.extend({
    ctor: function (controller, { closeWindowCallback }) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(cleverapps.resolution.getSceneSize());

        this.controller = controller;
        this.closeWindowCallback = closeWindowCallback;

        this.content = this.createContent();
        this.addChild(this.content);
        this.content.setPosition(this.width / 2, this.height / 2);

        const offer = cleverapps.offerManager.findOffer({ mission: controller.getType() });
        if (offer) {
            const tableParent = this.tableView.getParent();

            this.offerShade = new cc.Scale9Sprite(bundles.pixel.frames.pixel_png);
            this.offerShade.setColor(cleverapps.styles.COLORS.BLACK);
            this.offerShade.setOpacity(80);
            this.offerShade.setAnchorPoint(0.5, 0);
            this.offerShade.setPosition(tableParent.width / 2, 0);
            tableParent.addChild(this.offerShade, 1);

            this.windowOffer = new WindowOffer(tableParent, {
                text: Messages.get("KingsCupMissionWindow.offer"),
                offerType: offer.type,
                onClicked: () => {
                    this.closeWindowCallback();
                    cleverapps.offerManager.showOfferWindow(offer);
                },
                positioningStartOffset: this.content.width / 2,
                bundle: "kingscup_window",
                badgeText: Messages.get("KingsCupMissionWindow.offerBadge")
            });
            this.windowOffer.show();
            this.updateOfferPosition();
        }

        if (cleverapps.config.name === "mergecraft") {
            this.persons = new WindowPersons({
                role: "warlock",
                emotion: "happy"
            }, this, [this.content]);
        }

        controller.bus.on("hide", this.onHide.bind(this), this);
        controller.bus.on("show", this.onShow.bind(this), this);
    },

    createContent: function () {
        const styles = cleverapps.styles.KingsCupVertical;
        const controller = this.controller;

        const table = this.createTable();
        table.setAnchorPoint(0.5, 0.5);

        const titleSlot = this.backgroundSpine.getSlot("slot_title");
        const helpSlot = this.backgroundSpine.getSlot("slot_help");
        const timerSlot = this.backgroundSpine.getSlot("slot_timer");
        const timerBgSlot = this.backgroundSpine.hasSlot("slot_timer_bg") && this.backgroundSpine.getSlot("slot_timer_bg");
        const closeSlot = this.backgroundSpine.hasSlot("slot_close") && this.backgroundSpine.getSlot("slot_close");
        const clockSlot = this.backgroundSpine.getSlot("slot_clock");

        const mainTitle = cleverapps.UI.generateOnlyText(Messages.get("Missions.KingsCup.Title"), cleverapps.styles.FONTS.VERT_KINGS_CUP_TITLE_TEXT);
        titleSlot.addChild(mainTitle);
        mainTitle.setAlignment(titleSlot.width / 2, titleSlot.height / 2);
        mainTitle.fitTo(titleSlot.width, titleSlot.height);

        const helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.controller.getMission());
            }
        });
        helpSlot.addChild(helpButton);
        helpButton.setAlignment(helpSlot.width / 2, helpSlot.height / 2);
        helpButton.setScale(styles.helpButton.scale);
        helpButton.baseScale = helpButton.scale;

        if (closeSlot) {
            const closeButton = this.tableCloseButton = new CloseRoundButton({
                onClicked: this.closeWindowCallback,
                styles: styles.closeButton
            });
            closeSlot.addChild(closeButton);
        }

        if (timerBgSlot) {
            const timerBg = new cc.Scale9Sprite(bundles.timer.frames.timer_bg_png);
            timerBg.setContentSize2(timerBgSlot.getContentSize());
            timerSlot.setLocalZOrder(1);
            timerBgSlot.addChild(timerBg);
            timerBg.setAlignment(timerBgSlot.width / 2, timerBgSlot.height / 2);
        }

        if (controller.isRunning()) {
            let timeLeft = controller.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: this.closeWindowCallback
                });
            }

            const timer = new cleverapps.CountDownView(timeLeft, {
                font: cleverapps.styles.FONTS.VERT_KINGS_CUP_TIMER_TEXT
            });
            timerSlot.setLocalZOrder(2);
            timerSlot.addChild(timer);
            timer.fitTo(timerSlot.width, timerSlot.height);
            timer.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
        } else {
            const finishTitle = cleverapps.UI.generateOnlyText(Messages.get("Missions.windowFinished"), cleverapps.styles.FONTS.VERT_KINGS_CUP_TIMER_TEXT);
            timerSlot.addChild(finishTitle);
            finishTitle.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
            finishTitle.fitTo(timerSlot.width, timerSlot.height);
        }

        const clock = new cc.Sprite(bundles.big_timer.frames.big_timer_png);
        clockSlot.addChild(clock);
        clock.setPosition(clockSlot.width / 2, clockSlot.height / 2);

        return table;
    },

    createTable: function () {
        const controller = this.controller;

        const background = this.backgroundSpine = new cleverapps.Spine(bundles.missionboard.jsons.mission_board_vertical);
        background.setAnimation(0, "idle", true);

        const tableSlot = background.getSlot("slot_table");
        const table = controller.getTable();
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: { toEnd: false }
        });

        new TableHandler(table, tableView, {
            id: controller.getType(),
            height: tableSlot.height,
            rowConstructor: KingsCupRowView,
            rowOptions: {
                width: tableSlot.width,
                dataIcon: bundles.kingscup_table_row.frames.kingscup_icon,
                mission: controller.getMission()
            }
        });

        if (background.hasSlot("slot_board_bg")) {
            const boardBgSlot = background.getSlot("slot_board_bg");
            boardBgSlot.setLocalZOrder(-1);
            const boardBg = new cc.Scale9Sprite(bundles.kingscup.frames.mission_board_bg_png);
            boardBg.setContentSize2(boardBgSlot.getContentSize());
            boardBgSlot.addChild(boardBg);
            boardBg.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);

            boardBgSlot.addChild(tableView);
            tableView.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);
        } else {
            tableSlot.addChild(tableView);
            tableView.setAlignment(tableSlot.width / 2, tableSlot.height / 2);
        }

        const skin = (Mission.GetMissionType(controller.getType()) === Mission.TYPE_EXPEDITION_FEAST ? cleverapps.meta.selectedLocationId() : "")
            + controller.getName();

        if (background.hasSkin(skin)) {
            background.setSkin(skin);
        }

        return background;
    },

    createButton: function () {
        const styles = cleverapps.styles.KingsCupVertical;

        const controller = this.controller;

        if (controller.isRunning() && ["merge", "merge2"].includes(cleverapps.config.type)) {
            return;
        }

        let options = {
            width: styles.button.width,
            height: styles.button.height,
            type: styles.button.red && cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Play").toUpperCase(),

            onClicked: function () {
                this.closeWindowCallback();

                cleverapps.focusManager.distract({
                    focus: "MissionPlayButtonPressed",
                    action: function (f) {
                        Level.WantsToPlay(f);
                    }
                });
            }.bind(this)
        };

        if (!controller.isRunning()) {
            options = Object.assign(options, {
                type: cleverapps.styles.UI.Button.Images.button_blue,
                text: Messages.get(controller.getPrize() ? "ClaimPrize.Button.text" : "Close"),
                onClicked: this.closeWindowCallback
            });
        }

        const button = new cleverapps.UI.Button(options);
        button.setAlignment(styles.button);
        return button;
    },

    updateOfferPosition: function () {
        const tableParent = this.offerShade.getParent();

        let height = 0;
        this.tableView.innerContent.getChildren().forEach((row) => {
            const top = tableParent.convertToNodeSpace(row.convertToWorldSpace(cc.p(0, row.height))).y;
            if (top >= row.height / 2 && (!height || top < height)) {
                height = top;
            }
        });

        this.offerShade.setContentSize(tableParent.width, height);

        const offerButton = this.windowOffer.offerButton;
        if (offerButton) {
            offerButton.setAlignment({
                x: { align: "center" },
                y: { align: "bottom", dy: (height - offerButton.height) / 2 }
            });
        }
    },

    onResize: function () {
        this.setContentSize(cleverapps.resolution.getSceneSize());
        this.content.setPosition(this.width / 2, this.height / 2);

        if (this.windowOffer) {
            this.windowOffer.update();
            this.updateOfferPosition();
        }

        if (this.persons) {
            this.persons.update();
        }
    },

    onHide: function () {
        if (this.windowOffer) {
            this.windowOffer.hide(true);
            this.offerShade.setVisible(false);
        }
    },

    onShow: function () {
        if (this.windowOffer) {
            this.windowOffer.show();
            this.offerShade.setVisible(true);
            this.updateOfferPosition();
        }

        if (this.persons) {
            this.persons.showUp();
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    VERT_KINGS_CUP_TITLE_TEXT: {
        size: 78,
        color: cleverapps.styles.COLORS.MISSION_MAIN_TITLE_COLOR,
        stroke: cleverapps.styles.DECORATORS.TITLE_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.WINDOW_TITLE_SHADOW
    },

    VERT_KINGS_CUP_TIMER_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: undefined,
        shadow: undefined
    }
});

cleverapps.styles.KingsCupVertical = {
    margin: 30,

    tableStyles: {
        size: {
            width: 500,
            height: 732
        },

        margin: 7,
        padding: { x: 6, y: 2 },
        innerPadding: { x: 6, y: 12 },

        pinnedDy: 0,

        barPadding: {
            cornerPadding: 20,
            sidePadding: 5
        }
    },

    button: {
        x: { align: "center", dx: -25 },
        y: { align: "center" },
        width: 400,
        height: 110,
        red: true
    },

    helpButton: {
        scale: 1.4
    },

    closeButton: {
        scale: [0.7, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    }
};
